
import { defineComponent, computed } from 'vue';
import store from '@/store';

export default defineComponent({
  props: {
    adultAmount: Number,
    childAmount: Number,
    insuranceTotalPrice: Number,
  },
  setup(props) {
    const price = computed(() => store.state.ticketInfo.price);
    const getTotalPrice = computed(() => {
      return (
        ((props.adultAmount as number) + (props.childAmount as number) / 2) *
          store.state.ticketInfo.price +
        ((props.adultAmount as any) + (props.childAmount as any)) * 50 +
        (props.insuranceTotalPrice as any)
      );
    });
    return {
      price,
      getTotalPrice,
    };
  },
});
